import React, { useState } from 'react';
import { defaultFilterValues } from '~/api/config';
import { CompoundSlider } from '@boatsetter-backup/js-component-lib';
import styled from 'styled-components';
import { Trans } from '@lingui/react';

interface Props {
  maxSize: number;
  minSize: number;
  setMaxSize: any;
  setMinSize: any;
}

const BoatSizeFilter = React.memo(({ maxSize, minSize, setMaxSize, setMinSize }: Props) => {
  const changePrice = (sizeArr) => {
    const minSize = sizeArr[0];
    const maxSize = sizeArr[1];

    setMinSize(minSize);
    setMaxSize(maxSize);
  };

  const [higherStep, setHigherStep] = useState(true);

  return (
    <Wrapper>
      <CompoundSlider
        defaultValue={[minSize, maxSize]}
        label={<Trans id="boatSize.label" />}
        max={defaultFilterValues.maxBoatSize}
        min={defaultFilterValues.minBoatSize}
        onChange={(size) => {
          const minPricePercentage = (size[0] / defaultFilterValues.maxBoatSize) * 100;
          const maxPricePercentage = (size[1] / defaultFilterValues.maxBoatSize) * 100;

          setHigherStep(Math.min(minPricePercentage, maxPricePercentage) > 40);

          changePrice(size);
        }}
        pushable="5"
        step={higherStep ? 1 : 5}
        unit="'"
      />
    </Wrapper>
  );
});

const Wrapper = styled.div``;

export default BoatSizeFilter;
